import domContentLoaded from 'dom-content-loaded';
import $ from 'jquery';

export default () => {
	domContentLoaded(() => {
		const $dt = $('.js-q-and-a').find('dt');
		$dt.each((index, elm) => {
			$(elm).on('click', () => {
				if ($(elm).hasClass('is-open')) {
					$(elm).removeClass('is-open');
					$(elm).next().removeClass('is-open');
					$(elm).next().slideUp();
				} else {
					$(elm).addClass('is-open');
					$(elm).next().addClass('is-open');
					$(elm).next().slideDown();
				}
			});
		});
	});
};
